@if (signs) {
  <div id="signs">
    @for (sign of signs; track sign.fsw) {
      <fsw-sign [attr.sign]="sign.fsw" [matTooltip]="sign.description" (dblclick)="describeSign(sign)"></fsw-sign>
    }
  </div>
} @else {
  <ion-progress-bar type="indeterminate"></ion-progress-bar>
}
